var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRegistrationed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1655274632680,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 4620,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "@font-face { font-family: feedback-iconfont; src: url(\"//at.alicdn.com/t/font_1031158_u69w8yhxdu.woff2?t=1630033759944\") format(\"woff2\"), url(\"//at.alicdn.com/t/font_1031158_u69w8yhxdu.woff?t=1630033759944\") format(\"woff\"), url(\"//at.alicdn.com/t/font_1031158_u69w8yhxdu.ttf?t=1630033759944\") format(\"truetype\"); }\n"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M918.528 440.17664L583.81312 105.472a97.96608 97.96608 0 0 0-138.5472 0L110.54592 440.17664a98.05824 98.05824 0 0 0 0 138.53184L445.26592 913.408a97.9712 97.9712 0 0 0 138.5472 0l334.71488-334.69952a98.05824 98.05824 0 0 0 0-138.53184z m-283.95008 106.1632H551.424v83.12832a34.304 34.304 0 0 1-68.608 0v-83.12832H399.6928a34.304 34.304 0 1 1 0-68.608H482.816V394.60864a34.304 34.304 0 0 1 68.608 0V477.7472h83.13856a34.304 34.304 0 1 1 0.01536 68.59264z",
    fill: "#f6990d",
    "p-id": 4621
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegistrationed);
export default __webpack_public_path__ + "static/media/registrationed.e45c8675.svg";
export { ForwardRef as ReactComponent };